import { NgModule } from '@angular/core';
import { OyanTabNavModule } from '../tab-nav/tab-nav.module';
import { AppShellComponent } from './app-shell.component';
import { AppShellRouterModule } from './app-shell.router.module';

@NgModule({
  imports: [OyanTabNavModule, AppShellRouterModule, AppShellComponent]
})
export class OyanUiAppShellModule {}
